import constants from 'common/constants'

import {ONBOARDING_GET_DATA} from './ActionTypes/ApiActionTypes'

export const getOnboardingData = (onSuccess, onFailure) => {
  return {
    type: ONBOARDING_GET_DATA,
    payload: {
      apiUrl: constants.api_onboarding_data,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
